import React from 'react';
import {withNamespaces} from 'react-i18next';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const EditLink = ({t, onClick}) => (
  <button className="btn btn-link" style={{color: '#000'}} onClick={onClick}>
    <span className="mr-2">{t('edit')}</span>
    <FontAwesomeIcon icon="edit" />
  </button>
);

export default withNamespaces()(EditLink);